export function cellIsValid<T>(value: T) {
    return value !== undefined && value !== null;
}

export const getPaginationPageOptions = (rowCount: number) => {
    const options = PAGINATION_OPTIONS;
    return [{ label: "Show all", value: rowCount }, ...options];
};

export function calculateAlignmentValue<T>(value: T) {
    if (typeof value === "number") return "right";
    return "left";
}

export const PAGINATION_OPTIONS = [100, 200, 500];

export const splitTitleIntoNameAndUnit = (
    title: string
): {
    name: string;
    unit: string | null;
} => {
    const name = title.replace(/\s*\([^)]*\)\s*/, "");
    const unitMatchArray = title.match(/\(.*?\)/);
    const unit = unitMatchArray ? unitMatchArray[0] : null;

    return { name, unit };
};

function descendingComparator<T>(a: T, b: T, orderBy: keyof T) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

export function getComparator<T>(order: "asc" | "desc", orderBy: keyof T): (a: T, b: T) => number {
    return order === "desc"
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}
